export const daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
